export default __webpack_public_path__ + "static/media/icon-testimony.326bc47d.svg";